module.exports = __webpack_public_path__ + "media/images/icons/filled/appstore-a5603a0b96c53914348ad5c45f6a08cc.svg";